import { getCookie } from '../../utils/cookies';
import {
  optanonAlertBoxClosedCookieName,
  optanonConsentCookieName
} from '../../config/constants';

export class ConsentManager {
  public static hasUserConsented(): boolean {
    // Retrieve Cookies

    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);
    // Checking
    const consentGroupsRegex = /groups=1:1,2:1/; // Basic Functionality & Analytics
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }

  /**
   * Validates if user has consented to basic functionality only (group 1)
   */
  public static hasBasicFunctionalityConsent(): boolean {
    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);

    const consentGroupsRegex = /groups=1:1/; // Basic Functionality only
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }

  /**
   * Validates if user has consented to basic functionality and analytics (groups 1 and 2)
   */
  public static hasBasicAndAnalyticsConsent(): boolean {
    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);

    const consentGroupsRegex = /groups=1:1,2:1/; // Basic Functionality & Analytics
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }

  /**
   * Validates if user has consented to basic functionality, analytics and marketing (groups 1, 2 and 3)
   */
  public static hasBasicAnalyticsAndMarketingConsent(): boolean {
    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);

    const consentGroupsRegex = /groups=1:1,2:1,3:1/; // Basic Functionality, Analytics & Marketing
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }

  /**
   * Validates if user has consented to all groups (groups 1, 2, 3 and 4)
   */
  public static hasFullConsent(): boolean {
    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);

    const consentGroupsRegex = /groups=1:1,2:1,3:1,4:1/; // All consent groups
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }

  /**
   * Validates if user has consented to specific groups
   * @param groups Array of group numbers to check (e.g., [1, 2, 3])
   */
  public static hasConsentForGroups(groups: number[]): boolean {
    const optanonBoxClosed = getCookie(optanonAlertBoxClosedCookieName);
    const optanonConsent = getCookie(optanonConsentCookieName);

    const groupsPattern = groups.map((group) => `${group}:1`).join(',');
    const consentGroupsRegex = new RegExp(`groups=${groupsPattern}`);
    const consentBoxClosed = !!optanonBoxClosed.length;
    const consentFulfilled = consentGroupsRegex.test(optanonConsent);

    return consentBoxClosed && consentFulfilled;
  }
}
